import { apiCall } from "../../../services/api-service";
//Customer list
export const getCustomerListApi = async (params) => {
  try {
    const response = await apiCall("GET", "customer", null, {
      params: params,
    });
    return response;
  } catch (err) {
    console.error("Error fetching customer:", err);
  } finally {
  }
};
//Save Customer
export const saveCustomerAPI = async (body) => {
  try {
    const response = await apiCall("POST", "customer", body);
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching customer:", err);

    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
//Update Customer
export const updateCustomerAPI = async (id, body) => {
  try {
    const response = await apiCall("PUT", `customer/${id}`, body);
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching customer:", err);

    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
//Get Customer
export const getCustomerEditApi = async (id) => {
  try {
    const response = await apiCall("GET", `customer/get/${id}`);
    return response;
  } catch (err) {
    console.error("Error fetching customer:", err);
  } finally {
  }
};
//delete Customer
export const deleteCustomerApi = async (id) => {
  try {
    const response = await apiCall("DELETE", `customer/delete/${id}`);
    return response;
  } catch (err) {
    console.error("Error fetching customer:", err);
  } finally {
  }
};

// Update Customer Status
export const updateCustomerStatusApi = async (id, body) => {
  try {
    const response = await apiCall("PUT", `customer/status_update/${id}`, body);
    return response;
  } catch (err) {
    console.error("Error updating customer status:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

// Add Attachment
export const addAttachmentApi = async (id, body) => {
  try {
    const response = await apiCall("PUT", `customer/attachment/${id}`, body);
    return response;
  } catch (err) {
    console.error("Error adding attachment:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

// Add Profile Attachment
export const addProfileAttachmentApi = async (id, body) => {
  try {
    const response = await apiCall("PUT", `customer/profile_attachment/${id}`, body);
    return response;
  } catch (err) {
    console.error("Error adding profile attachment:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

// Download Customer Report
export const downloadCustomerReportApi = async (params) => {
  try {
    const response = await apiCall("GET", "customer/download_report", null, {
      params: params,
    });
    return response;
  } catch (err) {
    console.error("Error downloading customer report:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

// Download Template
export const downloadTemplateApi = async () => {
  try {
    const response = await apiCall("POST", "template_download", { type: "customer" });
    return response;
  } catch (err) {
    console.error("Error downloading template:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

// Upload Customer Excel
export const uploadCustomerExcelApi = async (base64File) => {
  try {
    const response = await apiCall("POST", "customer_excel_upload", { file: base64File });
    return response;
  } catch (err) {
    console.error("Error uploading customer excel:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

// Download base64 file utility
export const downloadBase64File = (base64String, fileName) => {
  try {
    const base64Data = base64String.replace(/^data:.*,/, "");
    const binary = atob(base64Data);
    const array = [];

    for (let i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }

    const blob = new Blob([new Uint8Array(array)], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error downloading file:", error);
  }
};
